/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetDateRangeRequest } from './WidgetDateRangeRequest';
import {
    WidgetDateRangeRequestFromJSON,
    WidgetDateRangeRequestFromJSONTyped,
    WidgetDateRangeRequestToJSON,
    WidgetDateRangeRequestToJSONTyped,
} from './WidgetDateRangeRequest';

/**
 * 
 * @export
 * @interface WidgetDateRangeCustom
 */
export interface WidgetDateRangeCustom extends WidgetDateRangeRequest {
    /**
     * 
     * @type {string}
     * @memberof WidgetDateRangeCustom
     */
    mode: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetDateRangeCustom
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetDateRangeCustom
     */
    to?: string;
}

/**
 * Check if a given object implements the WidgetDateRangeCustom interface.
 */
export function instanceOfWidgetDateRangeCustom(value: object): value is WidgetDateRangeCustom {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    return true;
}

export function WidgetDateRangeCustomFromJSON(json: any): WidgetDateRangeCustom {
    return WidgetDateRangeCustomFromJSONTyped(json, false);
}

export function WidgetDateRangeCustomFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDateRangeCustom {
    if (json == null) {
        return json;
    }
    return {
        ...WidgetDateRangeRequestFromJSONTyped(json, true),
        'mode': json['mode'],
        'from': json['from'] == null ? undefined : json['from'],
        'to': json['to'] == null ? undefined : json['to'],
    };
}

export function WidgetDateRangeCustomToJSON(json: any): WidgetDateRangeCustom {
    return WidgetDateRangeCustomToJSONTyped(json, false);
}

export function WidgetDateRangeCustomToJSONTyped(value?: WidgetDateRangeCustom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...WidgetDateRangeRequestToJSONTyped(value, true),
        'mode': value['mode'],
        'from': value['from'],
        'to': value['to'],
    };
}

